(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfect-for-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPerfectSlider(container) {
    if (!container || container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    var track = container.querySelector('.perfect-slider__track');
    var slides = Array.prototype.slice.call(
      container.querySelectorAll('.perfect-slide')
    );
    if (!track || slides.length === 0) return;

    var prevBtn = container.querySelector('.perfect-slider__btn--prev');
    var nextBtn = container.querySelector('.perfect-slider__btn--next');
    var dotsWrap = container.querySelector('.perfect-slider__dots');
    var current = 0;
    var interval;

    var autoRotate =
      container.getAttribute('data-auto-rotate') === 'true' &&
      slides.length > 1;
    var delay =
      parseInt(container.getAttribute('data-delay'), 10) * 1000 || 5000;

    if (dotsWrap && slides.length > 1) {
      slides.forEach(function (_, index) {
        var dot = document.createElement('span');
        dot.className =
          'perfect-slider__dot' + (index === 0 ? ' is-active' : '');
        dot.dataset.index = String(index);
        dotsWrap.appendChild(dot);
      });
    }

    var dots = Array.prototype.slice.call(
      container.querySelectorAll('.perfect-slider__dot')
    );

    function updateActiveSlide() {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
    }

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;

      track.style.transform = 'translateX(' + index * -100 + '%)';

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });

      updateActiveSlide();
    }

    function startAuto() {
      if (!autoRotate) return;
      stopAuto();
      interval = window.setInterval(function () {
        goTo(current + 1);
      }, delay);
    }

    function stopAuto() {
      if (interval) {
        window.clearInterval(interval);
        interval = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAuto();
        goTo(current - 1);
        startAuto();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAuto();
        goTo(current + 1);
        startAuto();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.index, 10);
        if (isNaN(index)) return;
        stopAuto();
        goTo(index);
        startAuto();
      });
    });

    container.addEventListener('mouseenter', stopAuto);
    container.addEventListener('mouseleave', startAuto);

    goTo(0);
    startAuto();
  }

  function initAllPerfectSliders(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll('.perfect-slider');
    sliders.forEach(initPerfectSlider);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllPerfectSliders(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllPerfectSliders(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-marquee"] && !Shopify.designMode) return;
  try {
    
  class ReviewMarquee {
    constructor() {
      this.gallery = document.querySelector('.review-marquee__gallery');
      this.rows = document.querySelectorAll('.review-marquee__scroll-content');
      this.isInitialized = false;

      // Bind methods to prevent memory leaks
      this.boundMethods = {
        pauseAll: this.pauseAll.bind(this),
        resumeAll: this.resumeAll.bind(this),
        recalculate: this.recalculate.bind(this),
      };

      this.init();
    }

    init() {
      if (this.isInitialized) return;

      try {
        // Wait for images to load before calculating dimensions
        this.waitForImages().then(() => {
          this.setupMarqueeAnimations();
          this.setupPauseOnHover();
          this.isInitialized = true;
        });
      } catch (error) {
        console.error('Marquee initialization error:', error);
      }
    }

    waitForImages() {
      return new Promise((resolve) => {
        const images = document.querySelectorAll('.review-marquee__image');
        let loadedCount = 0;
        const totalImages = images.length;

        if (totalImages === 0) {
          resolve();
          return;
        }

        const onImageLoad = () => {
          loadedCount++;
          if (loadedCount === totalImages) {
            resolve();
          }
        };

        images.forEach((img) => {
          if (img.complete) {
            onImageLoad();
          } else {
            img.addEventListener('load', onImageLoad);
            img.addEventListener('error', onImageLoad); // Count errors as loaded
          }
        });
      });
    }

    setupMarqueeAnimations() {
      this.rows.forEach((content) => {
        this.calculateAndApplyAnimation(content);
      });
    }

    calculateAndApplyAnimation(content) {

      // Get the content width
      const contentWidth = content.scrollWidth;

      const scrollDistance = contentWidth - window.innerWidth;

      // Set CSS custom property for the scroll distance
      content.style.setProperty('--scroll-distance', `-${scrollDistance}px`);

      // Add the animated class to start the animation
      content.classList.add('animated');
    }

    setupPauseOnHover() {
      if (!this.gallery || !this.gallery.hasAttribute('data-pause-on-hover')) return;

      // Use bound methods to prevent memory leaks
      this.gallery.addEventListener('mouseenter', this.boundMethods.pauseAll);
      this.gallery.addEventListener('mouseleave', this.boundMethods.resumeAll);
      this.gallery.addEventListener('touchstart', this.boundMethods.pauseAll);
      this.gallery.addEventListener('touchend', this.boundMethods.resumeAll);
    }

    pauseAll() {
      this.rows.forEach((row) => {
        row.style.animationPlayState = 'paused';
      });
    }

    resumeAll() {
      this.rows.forEach((row) => {
        row.style.animationPlayState = 'running';
      });
    }

    recalculate() {
      // Recalculate animations for responsive changes
      this.setupMarqueeAnimations();
    }

    // Simple cleanup method
    cleanup() {
      if (this.gallery) {
        this.gallery.removeEventListener('mouseenter', this.boundMethods.pauseAll);
        this.gallery.removeEventListener('mouseleave', this.boundMethods.resumeAll);
        this.gallery.removeEventListener('touchstart', this.boundMethods.pauseAll);
        this.gallery.removeEventListener('touchend', this.boundMethods.resumeAll);
      }
      this.boundMethods = null;
      this.isInitialized = false;
      this.gallery = null;
    }
  }

  // Initialize with proper error handling
  let marquee;

  const initializeMarquee = () => {
    try {
      marquee = new ReviewMarquee();
      window.reviewMarquee = marquee; // Make it globally accessible
    } catch (error) {
      console.error('Failed to initialize ReviewMarquee:', error);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMarquee);
  } else {
    initializeMarquee();
  }

  // Recalculate on window resize (with debouncing)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (marquee) {
        marquee.recalculate();
      }
    }, 250);
  });

  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    if (marquee) {
      marquee.cleanup();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
